'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { List } from 'immutable';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UICardSection from 'UIComponents/card/UICardSection';
import EmailForm from 'MeetingsLib/components/sections/EmailForm';
import DatePickerSection from 'MeetingsLib/components/sections/DatePickerSection';
import FreemiumBookingUpgradeLink from 'MeetingsLib/components/freemium/FreemiumBookingUpgradeLink';
import TimeOptionsSection from 'MeetingsLib/components/sections/TimeOptionsSection';
import PropertyForm from 'MeetingsLib/components/sections/PropertyForm';
import LegalConsentForm from 'MeetingsLib/components/sections/LegalConsentForm';
import UserProfile from 'MeetingsBase/models/UserProfile';
import WelcomeScreenInfo from 'MeetingsBase/models/WelcomeScreenInfo';
import Branding from 'MeetingsBase/models/Branding';
import BookingLifecycle from 'MeetingsLib/models/BookingLifecycle';
import FormState from 'MeetingsLib/models/FormState';
var FullSizeBookingPage = createReactClass({
  displayName: "FullSizeBookingPage",
  propTypes: {
    avatar: PropTypes.string,
    companyAvatar: PropTypes.string,
    displayAvatarOption: PropTypes.string,
    welcomeScreenInfo: PropTypes.instanceOf(WelcomeScreenInfo).isRequired,
    branding: PropTypes.instanceOf(Branding).isRequired,
    canSubmitInitialPropertyForm: PropTypes.bool,
    canTroubleshoot: PropTypes.bool,
    embedded: PropTypes.bool.isRequired,
    headline: PropTypes.string,
    isFetchingPublicAvailability: PropTypes.bool.isRequired,
    isSalesStarter: PropTypes.bool,
    isRescheduling: PropTypes.bool,
    profile: PropTypes.instanceOf(UserProfile).isRequired,
    shouldShowEmailForm: PropTypes.bool,
    bookingLifecycle: PropTypes.instanceOf(BookingLifecycle).isRequired,
    emailFormState: PropTypes.string,
    formState: PropTypes.instanceOf(FormState),
    recaptchaEnabled: PropTypes.bool.isRequired,
    legalConsentEnabled: PropTypes.bool.isRequired,
    legalConsentResponses: PropTypes.instanceOf(List),
    resetEventDateTime: PropTypes.func.isRequired,
    resetFormState: PropTypes.func.isRequired,
    submittingMeeting: PropTypes.bool,
    DatePickerMarker: PropTypes.func.isRequired,
    TimePickerMarker: PropTypes.func.isRequired,
    EmailFormMarker: PropTypes.func.isRequired
  },
  getClassNames: function getClassNames() {
    var _this$props = this.props,
        isSalesStarter = _this$props.isSalesStarter,
        canTroubleshoot = _this$props.canTroubleshoot,
        embedded = _this$props.embedded;
    return 'fullsize-container min-height-0 width-100 m-x-10 p-top-4' + (!isSalesStarter && !canTroubleshoot && !embedded ? " p-top-12" : "");
  },
  getLegalBackFunction: function getLegalBackFunction() {
    var _this$props2 = this.props,
        canSubmitInitialPropertyForm = _this$props2.canSubmitInitialPropertyForm,
        resetEventDateTime = _this$props2.resetEventDateTime,
        resetFormState = _this$props2.resetFormState,
        isRescheduling = _this$props2.isRescheduling;
    if (isRescheduling) return resetEventDateTime;
    return canSubmitInitialPropertyForm ? resetEventDateTime : resetFormState;
  },
  renderEmailForm: function renderEmailForm() {
    var _this$props3 = this.props,
        branding = _this$props3.branding,
        welcomeScreenInfo = _this$props3.welcomeScreenInfo,
        companyAvatar = _this$props3.companyAvatar,
        EmailFormMarker = _this$props3.EmailFormMarker;
    return /*#__PURE__*/_jsx(EmailForm, {
      branding: branding,
      compact: false,
      logoUrl: welcomeScreenInfo.logoUrl,
      companyAvatar: companyAvatar,
      title: welcomeScreenInfo.title,
      useCompanyLogo: welcomeScreenInfo.useCompanyLogo,
      description: welcomeScreenInfo.description,
      goToNextStep: function goToNextStep() {},
      EmailFormMarker: EmailFormMarker
    });
  },
  renderDateTimeStep: function renderDateTimeStep() {
    var _this$props4 = this.props,
        avatar = _this$props4.avatar,
        companyAvatar = _this$props4.companyAvatar,
        headline = _this$props4.headline,
        displayAvatarOption = _this$props4.displayAvatarOption,
        embedded = _this$props4.embedded,
        branding = _this$props4.branding,
        profile = _this$props4.profile,
        isFetchingPublicAvailability = _this$props4.isFetchingPublicAvailability,
        isSalesStarter = _this$props4.isSalesStarter,
        DatePickerMarker = _this$props4.DatePickerMarker,
        TimePickerMarker = _this$props4.TimePickerMarker;
    var dateContainerStyle = null;

    if (embedded && !isSalesStarter) {
      dateContainerStyle = {
        maxHeight: '613px'
      };
    }

    return /*#__PURE__*/_jsx(UICardWrapper, {
      className: "p-all-0 flex-column height-100",
      children: /*#__PURE__*/_jsx(UICardSection, {
        className: "p-all-0 height-100 flex-column",
        children: /*#__PURE__*/_jsxs(UIFlex, {
          className: "height-100",
          direction: "column",
          align: "stretch",
          children: [/*#__PURE__*/_jsxs(UIFlex, {
            direction: "row",
            className: "height-100",
            align: "stretch",
            style: dateContainerStyle,
            children: [/*#__PURE__*/_jsx(UIBox, {
              basis: "50%",
              children: /*#__PURE__*/_jsx(UIFlex, {
                direction: "column",
                className: "height-100",
                children: /*#__PURE__*/_jsx(DatePickerSection, {
                  compact: false,
                  avatar: avatar,
                  companyAvatar: companyAvatar,
                  branding: branding,
                  displayAvatarOption: displayAvatarOption,
                  embedded: embedded,
                  headline: headline,
                  profile: profile,
                  DatePickerMarker: DatePickerMarker,
                  TimePickerMarker: TimePickerMarker
                })
              })
            }), /*#__PURE__*/_jsx(UIBox, {
              basis: "50%",
              children: /*#__PURE__*/_jsx(UIFlex, {
                direction: "column",
                className: "height-100",
                children: /*#__PURE__*/_jsx(TimeOptionsSection, {
                  compact: false,
                  branding: branding,
                  profile: profile,
                  isFetchingPublicAvailability: isFetchingPublicAvailability,
                  TimePickerMarker: TimePickerMarker
                })
              })
            })]
          }), !isSalesStarter && /*#__PURE__*/_jsx(UIBox, {
            children: /*#__PURE__*/_jsx(FreemiumBookingUpgradeLink, {
              embedded: embedded
            })
          })]
        })
      })
    }, "full-datetime");
  },
  renderPropertyForm: function renderPropertyForm() {
    var _this$props5 = this.props,
        branding = _this$props5.branding,
        canSubmitInitialPropertyForm = _this$props5.canSubmitInitialPropertyForm,
        submittingMeeting = _this$props5.submittingMeeting,
        bookingLifecycle = _this$props5.bookingLifecycle,
        resetEventDateTime = _this$props5.resetEventDateTime;
    return /*#__PURE__*/_jsx(PropertyForm, {
      branding: branding,
      canSubmitInitialPropertyForm: canSubmitInitialPropertyForm,
      goToPreviousStep: resetEventDateTime,
      dateTime: bookingLifecycle.event.dateTime,
      submittingMeeting: submittingMeeting
    }, "full-property");
  },
  renderLegalConsentFormSection: function renderLegalConsentFormSection() {
    var _this$props6 = this.props,
        branding = _this$props6.branding,
        submittingMeeting = _this$props6.submittingMeeting,
        bookingLifecycle = _this$props6.bookingLifecycle;
    return /*#__PURE__*/_jsx(LegalConsentForm, {
      branding: branding,
      goToPreviousStep: this.getLegalBackFunction(),
      submittingMeeting: submittingMeeting,
      dateTime: bookingLifecycle.event.dateTime
    }, "full-legalConsent");
  },
  renderStep: function renderStep() {
    var _this$props7 = this.props,
        shouldShowEmailForm = _this$props7.shouldShowEmailForm,
        bookingLifecycle = _this$props7.bookingLifecycle,
        emailFormState = _this$props7.emailFormState,
        formState = _this$props7.formState,
        recaptchaEnabled = _this$props7.recaptchaEnabled,
        legalConsentEnabled = _this$props7.legalConsentEnabled,
        legalConsentResponses = _this$props7.legalConsentResponses,
        submittingMeeting = _this$props7.submittingMeeting,
        isRescheduling = _this$props7.isRescheduling;

    if (shouldShowEmailForm && !emailFormState) {
      return this.renderEmailForm();
    }

    if (!bookingLifecycle.event.dateString || !bookingLifecycle.event.dateTime) {
      return this.renderDateTimeStep();
    }

    if (!formState) {
      return this.renderPropertyForm();
    }

    if (legalConsentEnabled && !legalConsentResponses && !isRescheduling) {
      return this.renderLegalConsentFormSection();
    }

    if (submittingMeeting || recaptchaEnabled) {
      return this.renderLastStep();
    }

    return null;
  },
  renderLastStep: function renderLastStep() {
    var _this$props8 = this.props,
        legalConsentEnabled = _this$props8.legalConsentEnabled,
        isRescheduling = _this$props8.isRescheduling;

    if (legalConsentEnabled && !isRescheduling) {
      return this.renderLegalConsentFormSection();
    }

    return this.renderPropertyForm();
  },
  render: function render() {
    return /*#__PURE__*/_jsx(UIFlex, {
      direction: "column",
      className: this.getClassNames(),
      children: /*#__PURE__*/_jsx(CSSTransitionGroup, {
        transitionName: "step-animation",
        transitionEnterTimeout: 500,
        transitionLeave: false,
        className: "flex-column min-height-0 width-100 height-100",
        children: this.renderStep()
      })
    });
  }
});
export default connect(function (state) {
  return {
    isSalesStarter: state.isSalesStarter,
    isRescheduling: state.isRescheduling
  };
}, FormActions)(FullSizeBookingPage);